import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { BG_DARK, BG_LIGHT } from './constants/theme';
import { injectGlobalStyles } from './styles/global';
import { HomePage, BlogPostPage } from './pages';

function AppContent() {
  const [dark, setDark] = useState<boolean>(true);

  // Inject fonts + icons + theme CSS
  useEffect(() => {
    injectGlobalStyles();
  }, []);

  // Apply dark class to html
  useEffect(() => {
    document.documentElement.classList.toggle('dark', dark);
  }, [dark]);

  const pageProps = {
    dark,
    onToggleDark: () => setDark((v) => !v),
  };

  return (
    <div
      className="min-h-screen transition-colors duration-300"
      style={{ backgroundColor: dark ? BG_DARK : BG_LIGHT }}
    >
      <Routes>
        <Route path="/" element={<HomePage {...pageProps} />} />
        <Route path="/notes" element={<BlogPostPage {...pageProps} />} />
      </Routes>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}
